enum HTMLElementConfigContentModelEnum {
	rawText = 'rawText',
	noSelfDescendants = 'noSelfDescendants',
	noFirstLevelSelfDescendants = 'noFirstLevelSelfDescendants',
	noDescendants = 'noDescendants',
	anyDescendants = 'anyDescendants'
}

export default HTMLElementConfigContentModelEnum;
